
'use client';

import { useState, useEffect, useRef, useReducer, useMemo } from 'react';
import { _get, _post, _postBucket, _getBucketResult } from './apiClient';
import { cn } from "./lib/utils"
import { Button } from './@/components/ui/button';
import { Input } from './@/components/ui/input';
import { Label } from './@/components/ui/label';
import { Card, CardContent } from './@/components/ui/card';
import  DialogBox from './@/components/ui/dialog/dialog';
import { AlertCircle, CheckCircle2, Loader2, ChevronDown, Check, ChevronsUpDown } from 'lucide-react';
import { Trash2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './@/components/ui/select';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./@/components/ui/popover"
import './styles/globals.css';
import toast from 'react-hot-toast';
import CanvasJSReact from "@canvasjs/react-charts";
import { config_bucket_count } from './@/canvas_config/bar-chart';
import { barChartReducer } from './@/Reducers/canvas-reducer';
import { error } from 'node:console';
import { GoogleSpreadsheet } from 'google-spreadsheet';
import { Pagination } from "@heroui/react";
import { isReadable } from 'node:stream';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from './@/components/ui/hover-card';
import { Info } from "lucide-react";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

type CommentItem = {
  id: string;          // VERY important
  text: string;
  answer: string | null;
  job_code: any;
};

const preSelBuckets = [
  {
    id: 1,
    name: 'Brand Positive',
    isReadOnly: false
  },
  {
    id: 2,
    name: 'Brand Negative',
    isReadOnly: false
  },
  {
    id: 3,
    name: 'Influencer Positive',
    isReadOnly: false
  },
  {
    id: 4,
    name: 'Influencer Negative',
    isReadOnly: false
  },
  {
    id: 5,
    name: 'Others',
    isReadOnly: false
  }
];

const predefinedNames = [
  'Brand Positive',
  'Brand Negative',
  'Influencer Positive',
  'Influencer Negative',
  'Others'
];

const normalize = (str: string) => str.trim().toLowerCase();

const getChangedBuckets = (buckets: any[]) => {
  return buckets.filter(bucket =>
    !predefinedNames.map(normalize).includes(normalize(bucket.name))
  );
};

export default function OnboardingFlow() {
  const [activeBucket, setActiveBucket] = useState("All");
  const [step, setStep] = useState(1);
  const [urls, setUrls] = useState(['', '', '']);
  const [clientCode, setClientCode] = useState('');
  const [buckets, setBuckets] = useState(preSelBuckets);
  const [isProcessing, setIsProcessing] = useState(false);
  const [comments, setComments] = useState<CommentItem[]>([]);
  const [jobType, setJobType] = useState('new');
  const [taggedComments, setTaggedComments] = useState<{
    [key: string]: string[];
  }>({});
  const [visibleComments, setVisibleComments] = useState(100);
  const commentListRef = useRef<HTMLDivElement>(null);
  const [bucketBarOptions, dispatchBucketBarOptions] = useReducer(barChartReducer, config_bucket_count);
  const [analyticsData, setAnalyticsData] = useState<Array<object>>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [spreadSheetAnalytics, setSpreadSheetAnalytics] = useState('');
  const [jobList, setJobList] = useState<any[]>([]);
  const [comboboxOpen, setComboboxOpen] = useState(false);
  const [comboboxValue, setComboboxValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [jobCodeList, setJobCodeList] = useState<any[]>([]);
  const [runHistory, setRunHistory] = useState<any[]>([]);
  const [jobCodeBoxOpen, setJobCodeBoxOpen] = useState(false);
  const [selJobCodeValue, setSelJobCodeValue] = useState('');
  const lOctaToken:any = localStorage.getItem("okta-token-storage");
  const lBucketRenderJobCode:any = localStorage.getItem("bucket-job-code");
  const lIsAnalytics:any = localStorage.getItem("is-analytics");
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const lRedirectUrl = process.env.REACT_APP_OKTA_BASE_REDIRECT_URI;
  const [jobSubmitted, setJobSubmitted] = useState(false);
  const [brandContext, setBrandContext] = useState('');
  const [classificationStarted, setClassificationStarted] = useState(false);
  const [isJobCodesLoading, setIsJobCodesLoading] = useState(false);
  const [isRunHistoryLoading, setIsRunHistoryLoading] = useState(false);
  const [isGeneratingSuggestions, setIsGeneratingSuggestions] = useState(false);

  const stepLabels = [
  "Input Data",
  "Define Buckets",
  "Review & Classify",
  "Results & Analytics"
];

  useEffect(()=>{
    const match = comboboxValue.match(/\[(\d+)\]/);
    switch(jobType){
      case 'new':
        handleNewJobs(match);
        break;
      case 'old':
        handleAlreadyExistJobs(match);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[comboboxValue, jobType]);

  useEffect(()=>{
    const lParseOcta = lOctaToken ? JSON.parse(lOctaToken): null;
    if(lParseOcta && 
      lParseOcta.idToken &&
      lParseOcta.idToken.claims && 
      lParseOcta.idToken.claims.name) {
      setUserName(lParseOcta.idToken.claims.name);
    }else{
      setUserName('');
    }
    if(lParseOcta && 
        lParseOcta.accessToken &&
        lParseOcta.accessToken.claims && 
        lParseOcta.accessToken.claims.sub) {
        setUserEmail(lParseOcta.accessToken.claims.sub);
    }else{
        setUserEmail('');
    }
  },[lOctaToken]);

  useEffect(()=>{
     if(lBucketRenderJobCode && lIsAnalytics){
      localStorage.removeItem("bucket-job-code");
      localStorage.removeItem("is-analytics");
      setSelJobCodeValue(lBucketRenderJobCode);
      handleViewAnalytics(4, lBucketRenderJobCode);
    }else if(lBucketRenderJobCode){
      localStorage.removeItem("bucket-job-code");
      setSelJobCodeValue(lBucketRenderJobCode);
      handleBucketStepRedirect(lBucketRenderJobCode);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lBucketRenderJobCode, lIsAnalytics]);

  const handleNewJobs = (aMatch: any) => {
    if (aMatch) {
      const numberInsideBrackets = aMatch[1];
      const lUniqueCode = generateJobCode(numberInsideBrackets);
      setSelJobCodeValue(lUniqueCode);
    } else {
      setSelJobCodeValue('');
    }
  };

  const handleAlreadyExistJobs = async (aMatch: any) => {
    if (aMatch) {
      try {
        setIsJobCodesLoading(true);
        setIsProcessing(true);

        const lClientCode = aMatch[1];
        const lGetResponse = (await _get(`get-job-codes/${lClientCode}`)).data;

        const parsedData = JSON.parse(lGetResponse);
        if (parsedData && parsedData.job_codes) {
          setJobCodeList(parsedData.job_codes);
        }

      } catch (error: any) {
        toast.error(error.message || 'No results found!');
      } finally {
        setIsProcessing(false);
        setIsJobCodesLoading(false);
      }
    }
  };

  function generateJobCode(clientCode: string) {
    const randomPart = Math.floor(Math.random() * 900) + 100;
    const timestampPart = Date.now().toString().slice(-5);
    return `${clientCode}-${randomPart}${timestampPart}`;
  }

  const fetchRunHistory = async (jobCode: string) => {
    try {
      setIsRunHistoryLoading(true);

      const res = await _getBucketResult(`get_run_history?job_code=${jobCode}`);
      const parsed =
        typeof res.data === "string" ? JSON.parse(res.data) : res.data;

      setRunHistory(parsed.runs || []);

      if (parsed.runs?.length > 0) {
        localStorage.setItem("run_id", parsed.runs[0].run_id);
      }

    } catch (err) {
      console.error("Run history error", err);
    } finally {
      setIsRunHistoryLoading(false); 
    }
  };

  const formatRunTime = (timestamp: string) => {
      return new Date(timestamp).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      }) + ' UTC';
    };

  // const items = useMemo(()=>{
  //   const indexOfLastComment = currentPage * visibleComments;
  //   const indexOfFirstComment = indexOfLastComment - visibleComments;
  //   return comments.slice(indexOfFirstComment, indexOfLastComment);
  // },[comments, currentPage, visibleComments]);

  // const totalPages = useMemo(()=>{
  //   return Math.ceil(comments.length / visibleComments);
  // },[comments.length, visibleComments]);

  const groupedComments = useMemo(() => {                   
  const map: Record<string, CommentItem[]> = {};

  comments.forEach((c) => {
    const key = c.answer || "Unassigned";
    if (!map[key]) {
      map[key] = [];
    }
    map[key].push(c);
  });

  return map;
}, [comments]);

  const bucketsToRender = useMemo<[string, CommentItem[]][]>(() => {
  return activeBucket === "All"
    ? Object.entries(groupedComments) as [string, CommentItem[]][]
    : [[activeBucket, groupedComments[activeBucket] || []]];
}, [activeBucket, groupedComments]);

  const addUrlField = () => {
    if (urls.length < 10) {
      setUrls([...urls, '']);
    }
  };

  const addBucketField = () => {
    if (buckets.length < 10) {
      setBuckets([...buckets, {id: buckets.length+1, name: '', isReadOnly:false}]);
    }
  };

  const handleUrlChange = (index: number, value: string) => {
    const newUrls = [...urls];
    newUrls[index] = value;
    setUrls(newUrls);
  };

  const handleBucketChange = (id: number, value: string) => {
    setBuckets((prev) =>
      prev.map((bucket) => {
        if (bucket.id === id) {
          return {
            ...bucket,
            name: value,
          };
        }
        return bucket;
      })
    );
  };

  const handleBucketStepRedirect = async (aJobCode:string|number) => {
    try{
      setIsProcessing(true);
      toast.loading('We are processing your request. Please wait.', {
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });
      let processResponse = (await _get(`get-scraped-data/${aJobCode}`)).data;

      // Fetch brand context
      const contextRes = await _get(`get-brand-context/${aJobCode}`);
      const parsed = typeof contextRes.data === "string"
        ? JSON.parse(contextRes.data)
        : contextRes.data;

      setBrandContext(parsed.brand_context || "");
      
      const parsedData = JSON.parse(processResponse);
      const extractedcomments: CommentItem[] = [];
      for (const subArray of parsedData) {
        extractedcomments.push({id: crypto.randomUUID(), text: subArray.text, answer: null, job_code: aJobCode});
      }
      toast.dismiss();
      setComments(extractedcomments);
      setStep(2);
    }catch(error: any){
      toast.dismiss();
      toast.error(error.message || 'No results found!');
      setIsProcessing(false);
    }
  };

const handleNextStep = () => {

  switch(step){
    case 1:
      handleStepOne();
      break;

    case 2:
      handleStepTwo();
      break;
    case 3:
      setClassificationStarted(true);
      handleStepThree();
      break;
    default:
      setStep(step + 1);
      break;
  }
};

  const handleStepOne = async () => {
    const filteredUrls = urls.filter((url) => url);
    if ((jobType === 'new') && (filteredUrls.length <= 0 || !clientCode)) {
      alert('Please enter URL and select client!');
      return;
    }
    if(!selJobCodeValue){
      alert('Please select Job!');
      return;
    }
    setIsProcessing(true);
    try {
      toast.loading('We are processing your request. Please wait.', {
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });

      let processResponse = '';
      if(jobType === 'old'){
        processResponse = (await _get(`get-scraped-data/${selJobCodeValue}`)).data;
      }else{
        processResponse = (
          await _post('scrape-json', {
            client_code: clientCode,
            post_urls: filteredUrls,
            job_code: selJobCodeValue,
            brand_context: brandContext,
            user: userName,
            user_email: userEmail,
            redirectUrl: lRedirectUrl + '?job_code=' + selJobCodeValue,
          })
        ).data;
      }
      const parsedData = JSON.parse(processResponse);
      
      if (jobType === 'old') {
        const extractedcomments: CommentItem[] = [];
        for (const subArray of parsedData) {
          extractedcomments.push({id: crypto.randomUUID(), text: subArray.text, answer: null, job_code: selJobCodeValue});
        }
        toast.dismiss();
        setComments(extractedcomments);
        setStep(2);
      } else if(parsedData.status === 'in-progress' && parsedData.task_id) {
        toast.dismiss();
        setIsProcessing(false);
        setJobSubmitted(true);
        // toast.success('Job is created successfully and scrapping is in-progress. Once scrapping is done we will send you a notification', {
        //   duration: 3000,
        //   style: {
        //     borderRadius: '10px',
        //     background: '#333',
        //     color: '#fff',
        //   },
        // });
        // resetFrontPage();
      } else {
        toast.dismiss();
        toast.error('Unable to process your request. Try again later', {
          duration: 3000,
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        });
      }
    } catch (error: any) {
      toast.dismiss();
      toast.error(error.message || 'No results found!');
      setIsProcessing(false);
      // console.log('Catching Error', error);
    }
  };

  const handleStepTwo = async () => {
    if (buckets.length < 3) {
      toast.error("Please add at least 3 buckets");
      return;
    }

    if (buckets.length > 10) {
      toast.error("Maximum 10 buckets allowed");
      return;
    }

    const hasEmpty = buckets.some(b => !b.name.trim());
    if (hasEmpty) {
      toast.error("Bucket names cannot be empty");
      return;
    }

    const names = buckets.map(b => b.name.trim().toLowerCase());
    const hasDuplicate = new Set(names).size !== names.length;

    if (hasDuplicate) {
      toast.error("Bucket names must be unique");
      return;
    }

    try {
      setIsProcessing(true);
      setIsGeneratingSuggestions(true);
      toast.loading('We are processing your request. Please wait.', {
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });

      const changedBuckets = getChangedBuckets(buckets);

      // If NO bucket changed → skip AI completely
      if (changedBuckets.length === 0) {
        toast.dismiss();
        setIsGeneratingSuggestions(false);

        // Move UI to Step 3 first
        setStep(3);

        // Show loader immediately
        setClassificationStarted(true);

        // Call classification AFTER UI update
        setTimeout(() => {
          handleStepThree();
        }, 0);

        return;
      }

      // Only send changed buckets to AI
      const bucketNames = changedBuckets.map((bucket) => bucket.name);

      const processResponse = (
          await _post('similar-comments', {
            client_code: clientCode,
            job_code: selJobCodeValue,
            user: userName,
            user_email: userEmail,
            text: bucketNames,
            brand_context: brandContext
          })
        ).data;

      let parsedData = JSON.parse(processResponse);
      parsedData = parsedData.data
      // Keep existing comments for predefined buckets
      const existingPredefinedComments = comments.filter(c =>
        predefinedNames.includes(c.answer || "")
      );

      // AI comments only for changed buckets
      const aiComments: CommentItem[] = [];

      for (const item of parsedData) {
        const bucketName = item.bucket;

        item.suggestions.forEach((element: { text: string }) => {
          aiComments.push({
            id: crypto.randomUUID(),
            text: element.text,
            answer: bucketName,
            job_code: selJobCodeValue
          });
        });
      }

      // Merge both
      const finalComments = [...existingPredefinedComments, ...aiComments];

      toast.dismiss();
      setComments(finalComments);
      setStep(3);
      setIsGeneratingSuggestions(false);
    } catch(error){
      toast.dismiss();
      setIsProcessing(false);
      toast.error('Please try again!');
    }
  };

  const handleStepThree = async () => {
    localStorage.removeItem("run_id");
    
    try {
      setIsProcessing(true);
      toast.loading('We are processing your request. Please wait.', {
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });
      const response = await _postBucket('classify', {
        job_code: selJobCodeValue,
        comments,
        buckets,
        brand_context: brandContext,
        user: userName,
        user_email: userEmail,
        redirectUrl:
          lRedirectUrl +
          '?job_code=' +
          selJobCodeValue +
          '&is_analytics=true',
      });

      console.log("API RESPONSE", response);

      let parsed;

      try {
        parsed =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;
      } catch (e) {
        console.error("JSON parse failed", response.data);
      }

      const run_id = parsed?.run_id;

      if (run_id) {
        localStorage.setItem("run_id", run_id);
      } else {
        console.error("run_id missing!", response);
      }

      toast.dismiss();
      setIsProcessing(false);
    } catch (error) {
      toast.dismiss();
      setIsProcessing(false);
      toast.error('Please try again!');
    }
  };

  const countLabel = useMemo(() => {
    if (!analyticsData) return []; // Early return if analyticsData is undefined
    const lLabelNameCount = analyticsData.reduce((acc: any, { answer }: any) => {
      acc[answer] = (acc[answer] || 0) + 1;
      return acc;
    }, {});
  
    return Object.entries(lLabelNameCount).map(([label, count]) => ({
      y: count,
      label,
      color: 'rgb(241, 0, 38)',
    }));
  }, [analyticsData]);
  
  useEffect(() => {
    // Dispatch the updated data points when countLabel changes
    dispatchBucketBarOptions({ type: 'datapoints', title: selJobCodeValue ,nextDataPoints: countLabel });
    dispatchBucketBarOptions({ type: 'title', title: selJobCodeValue + ' analytics'  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countLabel]);

  const handleTagComment = (comment: any, bucket: string) => {
    setTaggedComments((prev) => {
      const newTaggedComments = { ...prev };
      for(const key in newTaggedComments){
        if (newTaggedComments[key]) {
          // Check if newTaggedComments[bucket] includes the comment
          const index = newTaggedComments[key].indexOf(comment);
          if (index !== -1) {
            // If the comment is found, remove it from the array
            newTaggedComments[key].splice(index, 1);
          }
        }
      }
      if (!newTaggedComments[bucket]) {
        newTaggedComments[bucket] = [];
      }

      if (!newTaggedComments[bucket].includes(comment)) {
        newTaggedComments[bucket] = [...newTaggedComments[bucket], comment];
      }
      return newTaggedComments;
    });

    setComments((prev) => {
      const newElement = prev.map((ele)=>{
        if(ele.text === comment){
          return {
            id: ele.id,
            text: ele.text,
            answer: bucket,
            job_code: ele.job_code
          }
        }
        return ele;
      });
      return [...newElement];
    });
  };

  const changeJobType = (event: any) => {
    // console.log(event.target.value);
    setJobType(event.target.value);
    setJobSubmitted(false);
    resetFrontPage();
  };

  const handleViewAnalytics = async(nextStep: any, aAlternateJobCode = null) => {

    if(!selJobCodeValue && !aAlternateJobCode){
      alert('Please select Job ID!');
      return false;
    }
    getBucketResult(nextStep, aAlternateJobCode);
  };  

  const getBucketResult = async (nextStep: any, aAlternateJobCode = null) => {

    try{
      toast.loading('We are processing your request. Please wait.', {
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });
      const lJobCode = aAlternateJobCode === null ? selJobCodeValue : aAlternateJobCode;
      const runId = localStorage.getItem("run_id");

      const lResponse = (
        await _getBucketResult(
          runId
            ? `get_classification_results?run_id=${runId}`
            : `get_classification_results?job_code=${lJobCode}`
        )
      ).data;
      const parsedData = JSON.parse(lResponse);
      toast.dismiss();

      if (parsedData && parsedData?.spreadsheet_link) {
        setSpreadSheetAnalytics(parsedData?.spreadsheet_link);
      }

      // Handle "still processing" case
      if (!parsedData?.data || parsedData.data.length === 0) {
        toast("⏳ Processing is still ongoing. You’ll get a Slack update soon.");
        return;
      }

      // Only when data is ready
      setAnalyticsData(parsedData.data);
      setStep(nextStep);
    }catch(error:any){
      toast.dismiss();
      toast.error('No results found for the given job ID.');
      console.error(error);
    }
  };

  const handleDialogBox = () => {
    setIsOpen(!isOpen);
  }

  const handleNewComments = (comment: any, selBucket: string) => {

    setTaggedComments((prev) => {
      const newTaggedComments = { ...prev };
      for(const key in newTaggedComments){
        if (newTaggedComments[key]) {
          // Check if newTaggedComments[bucket] includes the comment
          const index = newTaggedComments[key].indexOf(comment);
          if (index !== -1) {
            // If the comment is found, remove it from the array
            newTaggedComments[key].splice(index, 1);
          }
        }
      }
      if (!newTaggedComments[selBucket]) {
        newTaggedComments[selBucket] = [];
      }

      if (!newTaggedComments[selBucket].includes(comment)) {
        newTaggedComments[selBucket] = [...newTaggedComments[selBucket], comment];
      }
      return newTaggedComments;
    });

    setComments((prev:any)=>{
      return [
        ...prev,
        {
          id: crypto.randomUUID(),
          text: comment,
          answer: selBucket,
          job_code: selJobCodeValue
        }
      ]
    });
  };

  const getJobList = async () => {
    const SPREADSHEET_ID = '1O91RDryfrGK-8vpRx-wgNflFfLX45qlSaqygQN2Ju-Y';
    const API_KEY =  process.env.REACT_APP_GOOGLE_API_KEY || "";
    const SHEET_NAME = 'Sheet1';

    type UsersRowData = {
      "Job Number": string;
      "Job Name": string;
    };

    try {
      const doc = new GoogleSpreadsheet(SPREADSHEET_ID, { apiKey: API_KEY });
      await doc.loadInfo();
      const sheet = doc.sheetsByTitle[SHEET_NAME];
      const rows = await sheet.getRows<UsersRowData>();
      setJobList(rows.map(row => row.toObject()));
    } catch (error: any) {
      console.log('Error fetching data from Google Sheets:', error);
      toast.dismiss();
      toast.error(error.message || 'No results found!');
    }
  }

  useEffect(() => {
    getJobList()
  }, []);

  useEffect(() => {
    let interval: any;

    if (classificationStarted && selJobCodeValue) {
      interval = setInterval(async () => {

        // STOP if user already reset
        if (!classificationStarted) return;

        try {
          const runId = localStorage.getItem("run_id");

          const res = await _getBucketResult(
            runId
              ? `get_classification_results?run_id=${runId}`
              : `get_classification_results?job_code=${selJobCodeValue}`
          );

          const parsed =
            typeof res.data === "string"
              ? JSON.parse(res.data)
              : res.data;

          if (parsed?.data && parsed.data.length > 0) {
            clearInterval(interval);

            // double safety
            if (!classificationStarted) return;

            setAnalyticsData(parsed.data);

            if (parsed?.spreadsheet_link) {
              setSpreadSheetAnalytics(parsed.spreadsheet_link);
            }

            setClassificationStarted(false);
            setStep(4);
          }

        } catch (err) {
          console.error("Polling error", err);
        }
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [classificationStarted, selJobCodeValue]);

  const handlePageChange = (pageNumber:any) => {
    setCurrentPage(pageNumber);
  };

  const resetFrontPage = () => {
    setUrls(['', '', '']);
    setComboboxValue('');
    setClientCode('');
    // DO NOT clear job code here
    // setSelJobCodeValue('');
    setJobCodeList([]);
  };

  const handleRemoveBucket = (id:Number) => {
    setBuckets((prev) =>
      prev.filter((bucket) => bucket.id !== id)
    );
  };

  const handleRemoveComment = (id: string) => {
    setComments((prevComments) =>
      prevComments.filter((comment) => comment.id !== id)
    );
  };

  const resetAllAndStartNew = () => {
    setClassificationStarted(false);
    setStep(1);

    // Force NEW job flow
    setJobType('new');

    // URLs
    setUrls(['', '', '']);

    // Buckets
    setBuckets([...preSelBuckets]);

    // Comments
    setComments([]);
    setTaggedComments({});

    // Client + Job
    setClientCode('');
    setSelJobCodeValue('');
    setComboboxValue('');  
    setJobCodeList([]);
    setRunHistory([]);

    // Close dropdowns
    setComboboxOpen(false);
    setJobCodeBoxOpen(false);

    // Other
    setJobSubmitted(false);
    setBrandContext('');
    setAnalyticsData([]);

    // Cleanup
    localStorage.removeItem("run_id");
  };

  const isStepTwoInvalid = () => {
    if (buckets.length < 3 || buckets.length > 10) return true;

    const hasEmpty = buckets.some(b => !b.name.trim());
    if (hasEmpty) return true;

    const names = buckets.map(b => b.name.trim().toLowerCase());
    const hasDuplicate = new Set(names).size !== names.length;

    if (hasDuplicate) return true;

    return false;
  };

  const getStepTwoErrors = () => {
    const errors: string[] = [];

    if (buckets.length < 3) {
      errors.push("At least 3 buckets required");
    }

    if (buckets.length > 10) {
      errors.push("Maximum 10 buckets allowed");
    }

    if (buckets.some(b => !b.name.trim())) {
      errors.push("Bucket names cannot be empty");
    }

    const names = buckets.map(b => b.name.trim().toLowerCase());
    if (new Set(names).size !== names.length) {
      errors.push("Bucket names must be unique");
    }

    return errors;
  };

  const hasBucketChanges = useMemo(() => {
    const changed = getChangedBuckets(buckets);
    return changed.length > 0;
  }, [buckets]);

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="max-w-4xl mx-auto">
        <h1
          onClick={resetAllAndStartNew}
          className="text-4xl font-bold mb-8 text-center text-yellow-400 cursor-pointer hover:opacity-80"
        >
          COSA: Customizable Online Sentiment Analyzer
        </h1>

        {/* Stepper */}
        <div className="flex justify-between mb-8">
          {[1, 2, 3, 4].map((s) => (
            <div
              key={s}
              className={`w-1/5 text-center ${
                s === step
                  ? 'custom-text-mbooth'
                  : s < step
                  ? 'custom-text-mbooth'
                  : 'text-gray-400'
              }`}
            >
              <div
                className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${
                  s === step
                    ? 'custom-bg-mbooth text-white'
                    : s < step
                    ? 'custom-bg-mbooth'
                    : 'bg-gray-600'
                }`}
              >
                {s < step ? <CheckCircle2 className="w-5 h-5 text-black" /> : s}
              </div>
              <div className="mt-2 text-xs font-medium">
                Step {s}
              </div>
              <div className="text-sm">
                {stepLabels[s - 1]}
              </div>
            </div>
          ))}
        </div>

        <Card className="bg-white text-gray-800">
          <CardContent className="p-6">

            {step === 1 && (
              <div>
                <h2 className="text-2xl font-semibold mb-2 text-black">
                  Step 1: Enter URLs and Client Details
                </h2>

                <p className="text-sm text-gray-600 mb-4">
                  Provide the URLs (1-10) you want to analyze and select the client.  
                  This will allow the system to scrape comments and prepare them for classification.
                </p>
                <div>
                  <div className='mb-2 mr-3 inline-block'>
                    <input 
                      type='radio' 
                      id='new' 
                      name='jobType' 
                      value='new'
                      className='small'
                      onChange={changeJobType}
                      checked={jobType === 'new' ? true : false}
                    />
                    <Label htmlFor='new' className='cursor-pointer text-sm ml-1'>  Add a New Job</Label>
                  </div>

                  <div className='mb-2 inline-block'>
                    <input 
                      type='radio' 
                      id='old' 
                      name='jobType' 
                      value='old' 
                      className='small'
                      onChange={changeJobType}
                      checked={jobType === 'old' ? true : false}
                    />
                    <Label htmlFor='old' className='cursor-pointer text-sm ml-1'>Already Existing Job</Label>
                  </div>
                </div>
                {jobType === 'new' && 
                  <>
                    {urls.map((url, index) => (
                      <div key={index} className="mb-4">
                        <Label htmlFor={`url-${index}`} className='text-[12px] text-gray-500'>URL {index + 1}</Label>
                        <Input
                          id={`url-${index}`}
                          value={url}
                          onChange={(e) => handleUrlChange(index, e.target.value)}
                          className="mt-1 bg-gray-200 text-gray-700 border-gray-300 placeholder-gray-400"
                        />
                      </div>
                    ))}
                    {urls.length < 10 && (
                      <>
                        <div>
                          <span><i>Please include as many relevant URLs as needed (Facebook, Instagram, TikTok, YouTube) that link directly to the post(s) requiring analysis. Also, ensure the correct client code is included for billing purposes. This process can take up to 2 hours, depending on the volume of content to be analyzed.</i></span>
                        </div>
                        <div className='text-right'>
                          <Button
                            onClick={addUrlField}
                            variant="outline"
                            className="mb-4 bg-transparent shadow-none border-blue-200 hover:border-blue-700 text-blue-500 hover:bg-transparent hover:text-blue-700"
                          >
                            + Add URL
                          </Button>
                        </div>
                      </>
                    )}
                  </>
                }
                {jobType === 'new' && (
                  <div className="mb-4">
                    <Label className="text-[12px] text-gray-500">
                      Brand Context
                    </Label>

                    <textarea
                      className="mt-1 w-full p-2 bg-gray-200 text-gray-700 border border-gray-300 rounded-md"
                      placeholder="Describe the campaign: brand, goal, target audience, tone, or any context..."
                      value={brandContext}
                      onChange={(e) => setBrandContext(e.target.value)}
                    />
                  </div>
                )}
                <div className="mb-4">
                  <Label htmlFor="client-code" className='text-[12px] text-gray-500 flex items-center gap-1'>
                    Client Code

                    <HoverCard openDelay={200}>
                      <HoverCardTrigger asChild>
                        <span className="cursor-pointer">
                          <Info className="w-4 h-4 text-gray-400 hover:text-gray-600" />
                        </span>
                      </HoverCardTrigger>

                      <HoverCardContent className="w-80 text-sm bg-black text-white rounded-lg shadow-xl p-4">

                        <p className="font-semibold mb-2 text-yellow-400">
                          Billing Information
                        </p>

                        <p className="text-gray-300 mb-3">
                          Pricing is based on the number of comments processed.
                        </p>

                        <ul className="text-gray-400 text-xs space-y-1 mb-3">
                          <li>• Approx: every 500 comments = $X</li>
                          <li>• More comments → higher cost</li>
                          <li>• Each job is billed separately</li>
                        </ul>

                        <div className="bg-gray-800 p-2 rounded text-xs text-gray-300">
                          ⚠️ Scraping may incur charges even if analysis is not completed
                        </div>

                      </HoverCardContent>
                    </HoverCard>

                  </Label>
                  <Popover open={comboboxOpen} onOpenChange={setComboboxOpen}>
                    <PopoverTrigger asChild>
                      <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={comboboxOpen}
                        className="w-full justify-between mt-1 bg-gray-200 text-gray-700 border-gray-300 placeholder-gray-400 font-normal"
                      >
                        {comboboxValue
                          ? `${comboboxValue}`
                          : "Select Client" }
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="popover-content p-0" align="start">
                      <Command
                        filter={(value, search) => {console.log(value, search)
                          if (value.toLowerCase().includes(search.toLowerCase())) return 1
                          return 0
                        }}
                      >
                        <CommandInput placeholder="Search client code" />
                        <CommandList>
                          <CommandEmpty>No Client found.</CommandEmpty>
                          <CommandGroup>
                            {jobList.map((item, iIndex) => (
                              <CommandItem
                                key={iIndex}
                                value={`[${item['Job Number']}] ${item['Job Name']}`}
                                onSelect={(currentValue) => {
                                  setComboboxValue(currentValue === comboboxValue ? "" : currentValue)
                                  setComboboxOpen(false)
                                  setClientCode(currentValue === comboboxValue ? "" : currentValue.match(/\[([^\]]+)\]/)?.[1] ?? '')
                                  setSelJobCodeValue('')
                                }}
                              >
                                <Check
                                  className={cn(
                                    "mr-2 h-4 w-4",
                                    comboboxValue === `[${item['Job Number']}] ${item['Job Name']}` ? "opacity-100" : "opacity-0"
                                  )}
                                />
                                {`[${(item['Job Number'])}] ${item['Job Name']}`}
                              </CommandItem>
                            ))}
                          </CommandGroup>
                        </CommandList>
                      </Command>
                    </PopoverContent>
                  </Popover>
                </div>
                {jobSubmitted && (
                  <div className="mt-4 p-3 bg-green-50 border-l-4 border-green-500 text-sm text-green-800 rounded">
                    <b>✅ Job submitted successfully</b>

                    <div className="mt-1 text-sm">
                      Job ID: <span className="font-semibold text-green-900">{selJobCodeValue}</span>
                    </div>

                    <div className="mt-2">
                      Scraping is in progress. This may take some time depending on volume.
                    </div>

                    <div className="mt-2">
                      You’ll receive a Slack notification when scraping is complete.
                    </div>

                    <div className="mt-2 font-medium">Next steps:</div>
                    <ul className="list-disc ml-5 mt-1">
                      <li>Select <b>Already Existing Job</b></li>
                      <li>Choose your <b>Job ID</b></li>
                      <li>Click <b>Classify</b></li>
                    </ul>
                  </div>
                )}
                {jobType === 'old' && (
                  <div className='mb-4'>
                    <Label htmlFor="job-code" className='text-[12px] text-gray-500'>Job ID</Label>
                    <Popover open={jobCodeBoxOpen} onOpenChange={setJobCodeBoxOpen}>
                      <PopoverTrigger asChild>
                        <Button
                          variant="outline"
                          role="combobox"
                          disabled={isJobCodesLoading}
                          aria-expanded={jobCodeBoxOpen}
                          className="w-full justify-between mt-1 bg-gray-200 text-gray-700 border-gray-300 placeholder-gray-400 font-normal"
                        >
                          {isJobCodesLoading ? (
                            <span className="flex items-center gap-2">
                              <Loader2 className="h-4 w-4 animate-spin" />
                              Loading Job IDs...
                            </span>
                          ) : selJobCodeValue ? (
                            `${selJobCodeValue}`
                          ) : (
                            "Select Job ID"
                          )}
                          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="popover-content p-0" align="start">
                        <Command
                          filter={(value, search) => {
                            if (value.toLowerCase().includes(search.toLowerCase())) return 1
                            return 0
                          }}
                        >
                          <CommandInput placeholder="Search Job ID" />
                          <CommandList>
                            <CommandEmpty>No jobs found.</CommandEmpty>
                            <CommandGroup>
                              {jobCodeList.map((item, iIndex) => (
                                <CommandItem
                                  key={iIndex}
                                  value={`${jobCodeList[iIndex]}`}
                                  onSelect={async (currentValue) => {
                                    const selected =
                                      currentValue === selJobCodeValue ? "" : currentValue;

                                    setSelJobCodeValue(selected);
                                    setJobCodeBoxOpen(false);

                                    if (selected) {
                                      fetchRunHistory(selected);
                                      
                                      try {
                                        const contextRes = await _get(`get-brand-context/${selected}`);
                                        const parsed = typeof contextRes.data === "string"
                                          ? JSON.parse(contextRes.data)
                                          : contextRes.data;

                                        setBrandContext(parsed.brand_context || "");
                                      } catch (e) {
                                        console.error("Failed to fetch brand context");
                                      }
                                    }
                                  }}
                                >
                                  <Check
                                    className={cn(
                                      "mr-2 h-4 w-4",
                                      selJobCodeValue === `${jobCodeList[iIndex]}` ? "opacity-100" : "opacity-0"
                                    )}
                                  />
                                  {`${jobCodeList[iIndex]}`}
                                </CommandItem>
                              ))}
                            </CommandGroup>
                          </CommandList>
                        </Command>
                      </PopoverContent>
                    </Popover>
                  </div>
                )}

                {jobType === 'old' && selJobCodeValue && (
                  <div className='mb-4'>
                    <Label className='text-[12px] text-gray-500'>
                      Run History
                    </Label>

                    {isRunHistoryLoading ? (
                      <div className="mt-2 flex items-center gap-2 text-sm text-gray-500">
                        <Loader2 className="h-4 w-4 animate-spin" />
                        Fetching run history...
                      </div>
                    ) : runHistory.length > 0 ? (
                      <Select
                        defaultValue={runHistory[0]?.run_id}
                        onValueChange={(value) => {
                          localStorage.setItem("run_id", value);
                        }}
                      >
                        <SelectTrigger className="mt-1 bg-gray-200 text-gray-700">
                          <SelectValue placeholder="Select run" />
                        </SelectTrigger>

                        <SelectContent>
                          {runHistory.map((run, index) => (
                            <SelectItem key={index} value={run.run_id}>
                              {index === 0
                                ? `${formatRunTime(run.created_at)} (Latest)`
                                : formatRunTime(run.created_at)}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    ) : (
                      <div className="mt-2 text-sm text-gray-500">
                        No run history found
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {step === 2 && (
              <div>
                <h2 className="text-2xl font-semibold mb-4">
                  Step 2: Classification Buckets
                </h2>
                <p className="text-gray-500 text-sm mb-2">
                  We’ve provided 5 commonly used sentiment buckets to help you get started quickly:
                </p>

                <div className="flex flex-wrap gap-2 mb-2">
                  {[
                    "Brand Positive / Negative",
                    "Influencer Positive / Negative",
                    "Others"
                  ].map((item, i) => (
                    <span
                      key={i}
                      className="px-2 py-1 bg-gray-200 rounded text-xs text-gray-700"
                    >
                      {item}
                    </span>
                  ))}
                </div>

                <p className="text-gray-500 text-sm mb-3">
                  You can edit, remove, or add your own buckets based on your analysis needs.
                </p>

                <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded-md flex items-center gap-2">

                  <span className="text-xs text-gray-600 whitespace-nowrap">
                    Brand Context
                  </span>

                  <span className="text-sm text-gray-800 truncate">
                    {brandContext || "No context provided"}
                  </span>

                </div>

                <div className="text-gray-500 text-sm mb-3">
                  <p className="font-semibold inline">Requirements: </p>
                  <span>Minimum: 3 buckets | Maximum: 10 buckets</span>
                </div>

                <div className="mb-4">

                  <div className="text-gray-500 text-sm mb-1">
                    Default buckets are already optimized for classification.
                  </div>

                  <div className="text-yellow-600 text-sm font-semibold mb-2">
                    AI suggestions will only be generated for buckets you modify.
                  </div>

                  <div className="text-yellow-600 text-sm">
                    <span className="font-semibold">Tip:</span> Use clear and distinct labels so the AI can classify comments more accurately.
                  </div>

                </div>

                {isStepTwoInvalid() && (
                  <div className="text-red-500 text-sm mb-4">
                    <p>Please fix the following before continuing:</p>
                    {getStepTwoErrors().map((err, index) => (
                      <div key={index}>• {err}</div>
                    ))}
                  </div>
                )}
                {buckets.map((bucket, index) => (
                  <div key={index} className="mb-4">
                    <Label
                      htmlFor={`bucket-${index}`}
                      className="text-[12px] text-gray-500"
                    >
                      Bucket {index + 1}
                    </Label>

                    <div className="flex items-center gap-3 mt-1">
                      <Input
                        id={`bucket-${index}`}
                        placeholder="Enter a clear category (e.g., Positive Feedback, Negative Reviews, Neutral Mentions)"
                        value={bucket.name}
                        readOnly={bucket.isReadOnly}
                        onChange={(e) =>
                          handleBucketChange(bucket.id, e.target.value)
                        }
                        className="flex-1 bg-gray-200 text-gray-700 border-gray-300 placeholder-gray-400"
                      />

                      {!bucket.isReadOnly && (
                        <button
                          title="Remove bucket"
                          onClick={() => handleRemoveBucket(bucket.id)}
                          className="flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-md bg-red-100 hover:bg-red-500 transition"
                        >
                          <Trash2 className="w-4 h-4 text-red-600 hover:text-white" />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                {buckets.length < 10 && (
                  <div className='text-right'>
                  <Button
                    onClick={addBucketField}
                    variant="outline"
                    className="mb-4 bg-transparent shadow-none border-blue-200 hover:border-blue-700 text-blue-500 hover:bg-transparent hover:text-blue-700"
                  >
                    + Add Bucket
                  </Button>
                  </div>
                )}
              </div>
            )}

            {step === 3 && (
              <div>

                {/* SHOW LOADER AFTER CLASSIFICATION START */}
                {classificationStarted ? (
                  <div className="text-center py-10">

                    <Loader2 className="w-10 h-10 animate-spin mx-auto text-yellow-500 mb-4" />

                    <h2 className="text-2xl font-semibold mb-3">
                      Analysis in Progress
                    </h2>

                    <p className="text-gray-600 mb-4">
                      Your classification job has been successfully started.
                    </p>

                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 text-sm text-yellow-800 rounded inline-block text-left">
                      <p>⏳ Processing may take a few minutes depending on data size.</p>
                      <p className="mt-2">
                        📩 You will receive a <b>Slack notification</b> once results are ready.
                      </p>
                    </div>

                    <div className="mt-6 flex justify-center gap-3">
                      <Button
                        onClick={resetAllAndStartNew}
                        className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
                      >
                        Start New Analysis
                      </Button>
                    </div>

                  </div>
                ) : (
                  <>
                    <h2 className="text-2xl font-semibold mb-2">
                      Step 3: Top AI-Suggested Comments (Up to 20 per Bucket)
                    </h2>

                    <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded-md flex items-center gap-2">

                      <span className="text-xs text-gray-600 whitespace-nowrap">
                        Brand Context
                      </span>

                      <span className="text-sm text-gray-800 truncate">
                        {brandContext || "No context provided"}
                      </span>

                    </div>

                    <p className="mb-5 text-gray-400 text-[14px]">
                      {comments.length > 0 ? (
                        <>
                          Showing {comments.length} AI-suggested comments across {Object.keys(groupedComments).length} buckets (max 20 per bucket). Review and remove anything that doesn’t seem relevant.
                        </>
                      ) : (
                        "No AI suggestions were generated for the selected buckets."
                      )}
                    </p>

                    <div className='mb-3 text-right'>
                      <Button
                        className="bg-transparent custom-bg-mbooth text-white border-[0px]"
                        onClick={handleDialogBox}
                      >
                        Add Custom Comment +
                      </Button>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-4">
                      <button
                        onClick={() => setActiveBucket("All")}
                        className={`px-4 py-1.5 rounded-full ${
                          activeBucket === "All"
                            ? "bg-yellow-400 text-black"
                            : "bg-yellow-50 text-gray-800 border border-yellow-300"
                        }`}
                      >
                        All
                      </button>

                      {Object.keys(groupedComments).map((bucket) => (
                        <button
                          key={bucket}
                          onClick={() => setActiveBucket(bucket)}
                          className={`px-4 py-1.5 rounded-full ${
                            activeBucket === bucket
                              ? "bg-yellow-400 text-black"
                              : "bg-white text-gray-700 border border-yellow-300"
                          }`}
                        >
                          {bucket} ({groupedComments[bucket].length})
                        </button>
                      ))}
                    </div>

                    <div
                      ref={commentListRef}
                      className="h-96 overflow-y-auto mb-4 pr-2"
                    >
                      {bucketsToRender.length > 0 ? (
                        bucketsToRender.map(([bucket, bucketComments]) => (
                          <div key={bucket} className="mb-6">

                            <h3 className="text-lg font-semibold text-black mb-2">
                              {bucket} ({bucketComments.length})
                            </h3>

                            <div className="space-y-2">
                              {bucketComments.map((comment) => (
                                <div
                                  key={comment.id}
                                  className="flex items-center p-2 bg-gray-200 rounded"
                                >
                                  <span className="flex-1 text-[15px] break-words">
                                    {comment.text}
                                  </span>

                                  <button
                                    title="Remove comment"
                                    onClick={() => handleRemoveComment(comment.id)}
                                    className="flex items-center justify-center w-9 h-9 rounded-md bg-red-100 hover:bg-red-500 transition"
                                  >
                                    <Trash2 className="w-4 h-4 text-red-600 hover:text-white" />
                                  </button>
                                </div>
                              ))}
                            </div>

                          </div>
                        ))
                      ) : (
                        <div className="text-gray-500 text-sm text-center py-4">
                          No AI suggestions available for the selected buckets.
                          You can proceed with classification or add custom comments.
                        </div>
                      )}
                    </div>

                  </>
                )}

              </div>
            )}

            {step === 4 && (
              <div>
                <h2 className="text-2xl font-semibold mb-4">
                  Step 4: Final Notification
                </h2>
                <div className="flex items-center justify-between flex-wrap gap-4">
  
                  <div className='flex items-center'>
                    <CheckCircle2 className="text-green-500 mr-2" />
                    <span>
                      Analysis complete!
                    </span>
                  </div>

                  <div className="flex gap-3">

                    {spreadSheetAnalytics && (
                      <a
                        href={spreadSheetAnalytics}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-1.5 text-sm rounded-md custom-bg-mbooth text-white font-medium hover:opacity-90 transition"
                      >
                        View Analytics in Spreadsheet
                      </a>
                    )}

                    <Button
                      onClick={resetAllAndStartNew}
                      className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
                    >
                      Start New Analysis
                    </Button>

                  </div>
                </div>
                <div>
                  <CanvasJSChart options = {bucketBarOptions}/>
                </div>
              </div>
            )}

            <div className='flex justify-end gap-3 my-3 flex-wrap'>
              {step === 1 && jobType === 'new' && !jobSubmitted && (
                <div className="w-full mb-2 p-2 bg-yellow-50 border-l-4 border-yellow-400 text-xs text-yellow-800 rounded">
                  ⚠️ Scraping will start after submission and may incur charges based on data volume.
                </div>
              )}
              {step === 3 && (
                <Button
                  onClick={() => setStep(2)}
                  variant="outline"
                  disabled={classificationStarted}
                  className={cn(
                    "mb-4 bg-transparent shadow-none border-gray-200 text-gray-500",
                    classificationStarted
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:border-gray-700 hover:text-gray-700"
                  )}
                >
                  Back
                </Button>
              )}
              {step < 4 && (
                <Button
                  onClick={handleNextStep}
                  variant="outline"
                  disabled={
                    (step === 1 && (
                      isProcessing || 
                      jobSubmitted ||
                      (jobType === 'old' && (!selJobCodeValue || isRunHistoryLoading))
                    )) ||

                    (step === 2 && (isStepTwoInvalid() || isGeneratingSuggestions)) ||

                    (step === 3 && classificationStarted) ||

                    (step === 4 &&
                      !buckets.every((b) => taggedComments[b.name]?.length >= 5))
                  }
                  className="bg-transparent custom-bg-mbooth text-white border-[0px]"
                >
                  {step === 1 
                    ? (jobType === 'old'
                        ? 'Start Classification'
                        : jobSubmitted
                          ? 'Submitted'
                          : 'Start Scraping')

                    : step === 2
                      ? (hasBucketChanges ? 'Generate AI Suggestions' : 'Skip & Classify')

                    : step === 3 
                      ? 'Classify' 

                    : 'Next Step'}
                </Button>
              )}
              {step === 1 && jobType === 'old' && (
                <Button
                  onClick={() => handleViewAnalytics(4)}
                  disabled={
                    !selJobCodeValue ||
                    isRunHistoryLoading
                  }
                  className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
                >
                  View Classified Data
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
      <DialogBox 
        isOpen={isOpen} 
        handleDialogBox={handleDialogBox}
        handleNewComments={handleNewComments}
        bucketsList={buckets} 
      />
    </div>
  );
}